<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-caret-up`]" width="1em" height="1em" v-bind="$attrs"><path d="M8.4 30.352A1 1 0 009.162 32h29.676a1 1 0 00.761-1.648L24.762 12.896a1 1 0 00-1.524 0L8.4 30.352z"/></svg>
</template>
<script>

export default {
  name: 'IconCaretUp',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
